import { RootState } from "@/app/stores"
import { addUserToGroup, removeUserFromGroup } from "@/entities/groups"
import { addUser, removeUser } from "@/shared/api/groups"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

interface IChangeUserGroupRequest {
    groupId: string | null
}

export const fetchChangeUserGroup = createAsyncThunk<
    void,
    IChangeUserGroupRequest,
    { state: RootState }
>('changeUserGroup/fetchChangeUserGroup', async(data, thunkAPI) => {
    const { currentUser } = thunkAPI.getState().changeUserGroup
    const { groupId: newGroupId } = data
    const oldGroupId = currentUser.group_id
    const role = currentUser.role_id
    const userId = currentUser.id

    if (newGroupId === oldGroupId) {
        return
    }

    try {
        if (newGroupId) {
            await addUser(newGroupId, userId)
        } else if (oldGroupId) {
            await removeUser(oldGroupId, userId)
        }

        if (oldGroupId) {
            thunkAPI.dispatch(removeUserFromGroup({ groupId: oldGroupId, userId, role }))
        }
        if (newGroupId) {
            thunkAPI.dispatch(addUserToGroup({
                groupId: newGroupId,
                user: { id: userId, username: currentUser.username },
                role,
            }))
        }
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

